<div class="main-container">
  <div class="search-container">
    <img src="assets/icons/taxonomy_search.svg" alt="search-icon">
    <input class="search-input" placeholder="Search by name" type="text" (input)="onSearchChange($event)">
  </div>
  <div class="taxonomy-content">
    <div class="content-top-row">
      <taxonomy-dropdown (onItemSelect)="handleFilterSelect($event)"></taxonomy-dropdown>
      <div class="create-btn-container">
        @if (_taxonomiesCards().length>0) {
        <button class="btn-create-taxonomy" (click)="handleOpenNamePopup()">
          <img src="assets/icons/add-white.svg" alt="add-icon">
          <div class="btn-text">
            Create
          </div>
        </button>
        @if (_showNamePopup()) {
        <div class="name-popup-container">
          Let’s give taxonomy a name!
          <div class="input-container" [ngClass]="{'focused': inputFocused}">
            <input class="taxonomy-input" placeholder="Enter Name" type="text" (input)="onNameChange($event)"
              (focus)="inputFocused = true" (blur)="inputFocused = false">
          </div>
          <div class="button-container">
            <button class="btn-cancel-taxonomy" (click)="handleOpenNamePopup()">
              Cancel
            </button>
            <button class="btn-proceed-taxonomy" [disabled]="_taxonomyName().length === 0"
              [ngClass]="{'disabled': _taxonomyName().length === 0}" (click)="handleCreateTaxonomy()">
              Proceed
              <img src="assets/icons/taxonomy_arrow.svg" alt="taxonomy_arrow-icon">
            </button>
          </div>
        </div>
        }
        }
      </div>
    </div>
    <div class="taxonomy-cards-content">
      @if (_taxonomiesCards().length>0) {
      <div class="card-collection-container">
        <ng-container *ngFor="let taxonomy of getTaxonomyCards(); let i = index">
          <taxonomy-card [taxonomy]="taxonomy"></taxonomy-card>
        </ng-container>
      </div>
      } @else {
      <div class="empty-container">
        <img src="assets/icons/taxonomy_empty_main.svg" alt="empty-taxonomy-icon">
        <div class="empty-text">
          <span class="bold">No taxonomies yet?</span>
          <span>Start by naming and creating one to organise and </span>
          <span>manage your data seamlessly! 🚀 </span>
        </div>
        <div class="empty-input-container" [ngClass]="{'focused': inputFocused}">
          <div class="input-left">
            <div class="input-title">Your First Taxonomy Name</div>
            <input class="taxonomy-input" placeholder="Type here" type="text" (input)="onNameChange($event)"
              (focus)="inputFocused = true" (blur)="inputFocused = false">

          </div>
          <button class="btn-create-taxonomy" [ngClass]="{'disabled': _taxonomyName().length === 0}"
            [disabled]="_taxonomyName().length === 0" (click)="handleCreateTaxonomy()">
            <div class="btn-text" [ngClass]="{'disabled': _taxonomyName().length === 0}">
              Create
            </div>
          </button>
        </div>
      </div>
      }
    </div>

  </div>
</div>
